<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <v-container v-else class="Kanit px-5" grid-list-xs>
      <div style="text-align: center" class="py-2 mb-3">
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      </div>
      <h2 style="color: #0c4d9d" class="mb-8">กรอกใบแจ้งหนี้</h2>
      <div class="Kanit">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }" tag="form">
          <form @submit.prevent="handleSubmit(register)">
            <ValidationProvider
              :name="'ใบแจ้งหนี้'"
              :rules="'required'"
              key="invoice"
              v-slot="{ errors, valid }"
            >
              <v-textarea
                rows="3"
                auto-grow
                type="number"
                style="font-size: 20px"
                name="quotation"
                outlined
                v-model="input.quotation"
                label="ใบแจ้งหนี้"
                :error-messages="errors"
                :valid="valid"
              ></v-textarea>
            </ValidationProvider>

            <div class="text-center mt-0 mb-4">
              <v-btn type="submit" :loading="saveloading" dark color="#0c4d9d">
                ส่งให้ลูกค้า
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import UploadFile from "@/components/UploadProfile";
import Loading from "@/components/Loading.vue";
export default {
  data() {
    return {
      loading: true,
      saveloading: false,
      input: {
        quotation: "",
      },
    };
  },
  components: {
    Loading,
    UploadFile,
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  async mounted() {
    this.loading = false;
  },
  methods: {
    register() {
      if (!this.saveloading) {
        var vm = this;
        this.saveloading = true;

        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          quotation: this.input.quotation,
          customerid: this.query.customerid,
          type: this.query.type,
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toapaintersendquotation",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              await vm.$swal.fire({
                icon: "success",
                text: "กรุณารอการยืนยันจากลูกค้า",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "ไม่สำเร็จ",
              });
            }
          });
      }
    },
  },
};
</script>
